@if (account_form$ | async; as account_form) {
  <form [formGroup]="account_form">
    @if (account_service.accounts$ | async; as accounts) {
      <mat-form-field class="max-w-sm py-1" appearance="fill">
        <mat-label>Select Account</mat-label>
        <mat-select formControlName="account_id">
          @for (account of accounts; track account) {
            <mat-option [value]="account.account_id">{{
              account.name
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
}
